<template>
  <PlatDataPanelUniformExam :custom-id="customId">
    <template #default="{batchId}">
      <template v-if="batchId">
        <keep-alive>
          <ExamUniformScoreWrap :key="batchId"
                                :batch-id="batchId"></ExamUniformScoreWrap>
        </keep-alive>
      </template>
    </template>
  </PlatDataPanelUniformExam>
</template>

<script>
import PlatDataPanelUniformExam from '../../../wrapper/panel/PlatDataPanelUniformExam'
import ExamUniformScoreWrap from './wrap'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'ExamUniformScore',
  components: {
    PlatDataPanelUniformExam,
    ExamUniformScoreWrap
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>
